import { useEffect } from "react";
import { useTheme } from "next-themes";
import { useUserPreferences } from "./useUserPreferences";

/**
 * Applies the user's persisted theme + font-size scale to the document as
 * soon as preferences load, so every page inherits it regardless of whether
 * the user has visited the Settings page this session.
 */
export function useSyncAppearance(): void {
  const { data: prefs } = useUserPreferences();
  const { setTheme } = useTheme();

  useEffect(() => {
    if (prefs?.theme) setTheme(prefs.theme);
  }, [prefs?.theme, setTheme]);

  useEffect(() => {
    const scale = prefs?.fontSizeScale ?? 1;
    // Chakra v3 tokens are hardcoded in px, so changing <html> font-size
    // has no effect on Chakra components. CSS `zoom` scales the whole
    // render tree and works in Chromium/Firefox/Safari for this purpose.
    document.documentElement.style.zoom = String(scale);
  }, [prefs?.fontSizeScale]);
}
